import {
  Theme_Mode_Dark,
  Theme_Mode_Light,
  Theme_Storage_Key,
  type Theme_Mode,
} from "@/lib/theme/types";
import { Theme_Parse } from "@/lib/theme/parse";

export { Theme_Parse } from "@/lib/theme/parse";

export function Theme_Document_Apply(Mode: Theme_Mode): void {
  if (typeof document === "undefined") {
    return;
  }
  document.documentElement.setAttribute("data-theme", Mode);
  document.documentElement.style.colorScheme = Mode;
}

export function Theme_Storage_Read(): Theme_Mode | null {
  if (typeof window === "undefined") {
    return null;
  }
  try {
    return Theme_Parse(window.localStorage.getItem(Theme_Storage_Key));
  } catch {
    return null;
  }
}

export function Theme_Storage_Write(Mode: Theme_Mode): void {
  if (typeof window === "undefined") {
    return;
  }
  try {
    window.localStorage.setItem(Theme_Storage_Key, Mode);
  } catch {
    /* ignore quota / private mode */
  }
  Theme_Document_Apply(Mode);
}

/** Inline bootstrap — runs before paint to avoid flash. */
export function Theme_Bootstrap_Script(): string {
  return `(function(){try{var k=${JSON.stringify(Theme_Storage_Key)};var t=localStorage.getItem(k);if(t!==${JSON.stringify(Theme_Mode_Light)}&&t!==${JSON.stringify(Theme_Mode_Dark)}){t=${JSON.stringify(Theme_Mode_Light)};}var d=document.documentElement;d.setAttribute("data-theme",t);d.style.colorScheme=t;}catch(e){document.documentElement.setAttribute("data-theme",${JSON.stringify(Theme_Mode_Light)});}})();`;
}
